module.exports = __webpack_public_path__ + "img/file.df044f36.svg";